var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.419,
    height: 18,
    viewBox: "0 0 17.419 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "power-off-solid",
    d: "M25.871,9.29a1.161,1.161,0,1,1-2.323,0V1.161a1.161,1.161,0,1,1,2.323,0Zm-7.548,0a6.387,6.387,0,1,0,10.47-4.914,1.161,1.161,0,1,1,1.484-1.785,8.71,8.71,0,1,1-11.134,0,1.163,1.163,0,0,1,1.637.15,1.192,1.192,0,0,1-.152,1.635A6.379,6.379,0,0,0,18.323,9.29Z",
    transform: "translate(-16)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/off.142c2edf7bb2a72de7e95cb134a73d75.svg";